import capitalize from 'lodash/capitalize';

import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  cerTypes: string[];
};

/**
 * Mirrors QuestionTypesView, but the heading is the literal "CER" — an initialism
 * the ticket copy never expands or pluralises, so it takes no `pluralize` treatment.
 */
const CerTypesView = ({ cerTypes }: Props) => {
  return (
    <>
      <Heading16 as="h3" marginBottom={0} marginTop={12}>
        CER
      </Heading16>
      <Text>
        {cerTypes
          .map(cerType => capitalize(cerType))
          .sort()
          .join(', ')}
      </Text>
    </>
  );
};

export default CerTypesView;
